// English dictionary: the source language of the interface. One file per domain.
import common from './common.js';
import shell from './shell.js';
import settings from './settings.js';
import home from './home.js';
import activities from './activities.js';
import activity from './activity.js';
import progress from './progress.js';
import training from './training.js';
import charts from './charts.js';
import play from './play.js';
import online from './online.js';
import leaderboards from './leaderboards.js';
import friends from './friends.js';
import clubs from './clubs.js';
import account from './account.js';
import onboarding from './onboarding.js';
import sync from './sync.js';
import net from './net.js';
import ride from './ride.js';
import events from './events.js';
import devices from './devices.js';
import creations from './creations.js';
import challenges from './challenges.js';
import tour from './tour.js';
import replay from './replay.js';
import legal from './legal.js';
import landing from './landing.js';
import setup from './setup.js';
import remote from './remote.js';
import resume from './resume.js';

const en = {
  common,
  shell,
  settings,
  home,
  activities,
  activity,
  progress,
  training,
  charts,
  play,
  online,
  leaderboards,
  friends,
  clubs,
  account,
  onboarding,
  sync,
  net,
  ride,
  events,
  devices,
  creations,
  challenges,
  tour,
  replay,
  legal,
  landing,
  setup,
  remote,
  resume,
};
export type Dict = import('../types.js').Widen<typeof en>;
export default en as Dict;
